import type { StyledComponent } from 'styled-components';
import styled from 'styled-components';
import Dropdown from 'antd/lib/dropdown';

Dropdown.Button = styled(Dropdown.Button)`
  > .ant-btn:first-child {
    padding: 0;
  }
`;

export const StyledDropdown: StyledComponent<typeof Dropdown, any> = styled(Dropdown)``;
